/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validUsername(str) {
  const valid_map = ['admin', 'editor']
  return valid_map.indexOf(str.trim()) >= 0
}

/**
 * @param {string} url
 * @returns {Boolean}
 */
export function validURL(url) {
  const reg =
    /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/
  return reg.test(url)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validLowerCase(str) {
  const reg = /^[a-z]+$/
  return reg.test(str)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validUpperCase(str) {
  const reg = /^[A-Z]+$/
  return reg.test(str)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validAlphabets(str) {
  const reg = /^[A-Za-z]+$/
  return reg.test(str)
}

/**
 * @param {string} email
 * @returns {Boolean}
 */
export function validEmail(email) {
  const reg =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return reg.test(email)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function isString(str) {
  if (typeof str === 'string' || str instanceof String) {
    return true
  }
  return false
}

/**
 * @param {Array} arg
 * @returns {Boolean}
 */
export function isArray(arg) {
  if (typeof Array.isArray === 'undefined') {
    return Object.prototype.toString.call(arg) === '[object Array]'
  }
  return Array.isArray(arg)
}
/**
 * @param value
 * 密码是否满足条件
 */
export const validatePsdReg = (rule, value, callback) => {
  if (!value) {
    return callback(new Error('请输入密码'))
  }
  if (!/^(?![\d]+$)(?![a-zA-Z]+$)(?![^\da-zA-Z]+$)([^\u4e00-\u9fa5\s]){6,20}$/.test(value)) {
    callback(new Error('5-20位密码，字母、数字、符号至少2种'))
  } else {
    callback()
  }
}
/**
 * 清空error信息
 * @param form
 */
export const clearError = (form) => {
  try {
    form.resetFields()
  } catch (e) {}
}
/**
 * 空验证
 */
export const isEmpty = (val) => {
  if (val == '' || val == null || val == undefined) {
    if (val === 0) {
      return false
    }
    return true
  }
  return false
}

/**
 * 清空数据  (测试) Fanqi
 */
export const clearData = (data) => {
  for (let i in data) {
    if (typeof data[i] == 'object') {
      for (let j in data[i]) {
        data[i][j] = ''
      }
    } else {
      data[i] = ''
    }
  }
}
/**
 * 导出文件生成
 * @param {*} fileName 导出文件名
 * @param {*} data 文件流
 **/
export const exportFile = (fileName, data) => {
  let url = window.URL.createObjectURL(new Blob([data]))
  let link = document.createElement('a')
  link.style.display = 'none'
  link.href = url
  link.setAttribute('download', fileName)
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}
//名称校验
export const taskRule = (rule, value, callback) => {
  if (value) {
    const reg = /^[\a-\z\A-\Z0-9\u4e00-\u9fe5\_\-\@\(\)\!\%\&\#\']{2,64}$/
    if (reg.test(value)) {
      callback()
    } else {
      callback(new Error('2~64个字符,只支持中文、数字、英文字母和特殊字符_-@(),!%&#'))
    }
  }
}

// 验证手机号码
export const isHandset = (rule, value, callback) => {
  if (isEmpty(value)) {
    return callback()
  }
  var pattern = /^1[3456789]\d{9}$/
  if (!pattern.test(value)) {
    return callback(new Error('手机号格式不正确'))
  }
  return callback()
}

/**
 * 只能输入字母、数字
 */
export const isStr = (rule, value, callback) => {
  if (!value) {
    callback()
  } else {
    const reg = /^[\da-zA-Z]+$/
    if (reg.test(value)) {
      callback()
    } else {
      callback('请输入字母或数字')
    }
  }
}
/**
 * 只能输入字母、数字、符号
 */
export const isStrUrl = (rule, value, callback) => {
  if (!value) {
    callback()
  } else {
    const reg = /[\u4E00-\u9FA5]/g
    if (reg.test(value)) {
      callback('请输入字母或数字或符号')
    } else {
      callback()
    }
  }
}
/**
 * 账号验证：只能输入字母、数字、符号,必须包含两种
 */
export const isStrUrlAccount = (rule, value, callback) => {
  if (!value) {
    callback()
  } else if (!/^(?![\d]+$)(?![a-zA-Z]+$)(?![^\da-zA-Z]+$)([^\u4e00-\u9fa5\s]){5,25}$/.test(value)) {
    callback(new Error('5-25位，字母、数字、符号至少2种'))
  } else {
    callback()
  }
}

/**
 * 数字、小数点验证
 */
export const isNumber = (rule, value, callback) => {
  if (!value) {
    //当使用时没有定义text则非空验证默认提示请输入
    callback(new Error(rule.text ? rule.text : '请输入'))
  } else {
    // const reg = /^[0-9]*$/
    const reg = /^(?:[1-9]\d*|0)(?:\.\d{1,2})?$/
    if (reg.test(value)) {
      callback()
    } else {
      callback(new Error('请输入数字、且小数位不能超过两位'))
    }
  }
}
//只允许输入数字
export const isNum = (rule, value, callback) => {
  if (!value) {
    //当使用时没有定义text则非空验证默认提示请输入
    callback(new Error(rule.text ? rule.text : '请输入'))
  } else {
    // const reg = /^[0-9]*$/
    const reg = /^[0-9]*$/
    if (reg.test(value) && value >= 0) {
      callback()
    } else {
      callback('请输入数字')
    }
  }
}
//只允许输入数字
export const isDeviceNumber = (rule, value, callback) => {
  if (!value) {
    //当使用时没有定义text则非空验证默认提示请输入
    callback(new Error(rule.text ? rule.text : '请输入'))
  } else {
    // const reg = /^[0-9]*$/
    // reg = /^[0-9]{10,30}$/
    const reg = /^((9087)|(8607)|(0000))[0-9]{6,26}$/
    if (reg.test(value) && value >= 0) {
      callback()
    } else {
      callback('请输入正确的设备号')
    }
  }
}
// 中文验证
export const isChinese = (rule, value, callback) => {
  if (!value) {
    callback(new Error(rule.text ? rule.text : '请输入'))
  } else {
    const reg = /^[\u4e00-\u9fa5]+$/
    if (reg.test(value)) {
      callback()
    } else {
      callback('请输入汉字')
    }
  }
}

//只允许输入正整数
export const integer = (rule, value, callback) => {
  if (!value) {
    //当使用时没有定义text则非空验证默认提示请输入
    callback(new Error(rule.text ? rule.text : '请输入'))
  } else {
    const reg = /(^[1-9]\d*$)/
    if (reg.test(value) && value >= 0) {
      callback()
    } else {
      callback('请输入正整数')
    }
  }
}
